<div class="back-button-div">
  <span>{{ 'dashboard:'+ (isEdit?'Edit widget':'Add widget') | i18next }}</span>
</div>
<mat-horizontal-stepper #stepper linear (selectionChange)="stepperSelectionChange($event)" [class.one-identity]="isOneIdentity">

  <mat-step label="{{ 'dashboard:wizard step' | i18next:{No:1} }}" [editable]="!isEdit"
    [completed]="gridItem.componentType!=null">
    <div class="wizard-title">{{ 'dashboard:Select widget' | i18next }}</div>
    <div class="wizard-options-div select-widget">
      <div>
        <div class="help-icon">
          <button (click)="showHelp($event,2)"><i class="fal fa-question-circle"></i> </button>
        </div>
        <label>
          <input type="radio" name="dataType" [(ngModel)]="gridItem.componentType" [value]="2" (click)="resetSetup()"/>
          <div class="radio-container">
            <i class="fal fa-university"></i>
            <span>{{ 'dashboard:Traffic' | i18next }}</span>
            <span>{{ 'dashboard:Offered/Answered' | i18next }}</span>
          </div>
        </label>
      </div>
      <div>
        <div class="help-icon">
          <button (click)="showHelp($event,0)"><i class="fal fa-question-circle"></i> </button>
        </div>
        <label>
          <input type="radio" name="dataType" [(ngModel)]="gridItem.componentType" [value]="0" (click)="resetSetup()"/>
          <div class="radio-container">
            <i class="fal fa-users-class"></i>
            <span>{{ 'dashboard:Queue' | i18next }}</span>
          </div>
        </label>
      </div>
      <div>
        <div class="help-icon">
          <button (click)="showHelp($event,1)"><i class="fal fa-question-circle"></i> </button>
        </div>
        <label>
          <input type="radio" name="dataType" [(ngModel)]="gridItem.componentType" [value]="1" (click)="resetSetup()"/>
          <div class="radio-container">
            <i class="fal fa-user-headset"></i>
            <span>{{ 'dashboard:Agents' | i18next }}</span>
          </div>
        </label>
      </div>
      <div *ngIf="reportsEnabled">
        <div class="help-icon">
          <button (click)="showHelp($event,3)"><i class="fal fa-question-circle"></i> </button>
        </div>
        <label>
          <input type="radio" name="dataType" [(ngModel)]="gridItem.componentType" [value]="3" />
          <div class="radio-container">
            <i class="fal fa-chart-line"></i>
            <span>{{ 'dashboard:Historical' | i18next }}</span>
            <span>{{ 'dashboard:Reports' | i18next }}</span>
          </div>
        </label>
      </div>
      <div *ngIf="webEngageRuleMatchEnabled">
        <div class="help-icon">
          <button (click)="showHelp($event,4)"><i class="fal fa-question-circle"></i> </button>
        </div>
        <label>
          <input type="radio" name="dataType" [(ngModel)]="gridItem.componentType" [value]="4" />
          <div class="radio-container">
            <img src="assets/Img/visitor_tracking.svg" class="rule-Match-ico"/>
            <span>{{ 'dashboard:Web Engage' | i18next }}</span>
            <span>{{ 'dashboard:Rule Match' | i18next }}</span>
          </div>
        </label>
      </div>
    </div>
    <footer>
      <button matButton class="secondary-button" style="visibility: hidden;" matStepperPrevious>{{ 'Back' | i18next
        }}</button>
      <div>
        <button matButton [ngClass]="['secondary-button', 'cancel-button']" (click)="backToDashboard()" class="cancel-button">{{ 'Cancel' | i18next
          }}</button>
        <button matButton matStepperNext class="primary-button" [disabled]="gridItem.componentType==null">{{ 'Next' |
          i18next }}</button>
      </div>

    </footer>
  </mat-step>

  <mat-step label="{{ 'dashboard:wizard step' | i18next:{No:2} }}" [completed]="stepSelectDataSeriesComplited">
    <div class="wizard-title" *ngIf="gridItem.componentType!=3">{{ 'dashboard:Select data series' | i18next }}</div>
    <div class="wizard-title" *ngIf="gridItem.componentType==3">{{ 'dashboard:Configure Reports' | i18next }}</div>
    <div class="wizard-options-div">
      <app-widget-container [gridItem]="gridItem" [resolvewizard]="true" [isEdit]="isEdit" [stepper]="this.stepper"
        (complited)="stepSelectDataSeriesComplited=$event" [dataNotifier]="dataNotifier" #wcc></app-widget-container>
    </div>

    <footer class="footer-settings">
      <button matButton class="secondary-button" matStepperPrevious [disabled]="isEdit">{{ 'Previous' | i18next }}</button>
      <div>
        <button matButton [ngClass]="['secondary-button', 'cancel-button']" (click)="backToDashboard()">{{ 'Cancel' | i18next
          }}</button>
        <button matButton matStepperNext class="primary-button" [disabled]="!stepSelectDataSeriesComplited">{{ 'Next' |
          i18next }}</button>
      </div>

    </footer>
  </mat-step>

  <mat-step label="{{ 'dashboard:wizard step' | i18next:{No:3} }}" [completed]="gridItem.colorScheme>-1">
    <div class="wizard-title">{{ 'dashboard:Customize your widget' | i18next }}</div>
    <div class="wizard-options-div customize-widget">
      <div class="widget-properties">
        <app-widget-textbox [model]="gridItem.title" (modelChange)="gridItem.title=$event"
          title="{{ 'dashboard:Widget title' | i18next }}" textboxWidth="300px" placeholder="{{'dashboard:Type widget title here' | i18next}}..."></app-widget-textbox>
        <div class="color-schemes-select">
          <div class="title" [class.active]="colorSchemeSelectOpened">{{ 'dashboard:Style' | i18next }}</div>
          <ng-select [items]="colorSchemes" bindLabel="name" bindValue="id" [(ngModel)]="gridItem.colorScheme" placeholder="{{ 'Select'| i18next }}" [searchable]="false"
                     [class.active]="colorSchemeSelectOpened" (change)="onColorSchemeChange($event)" (focus)="colorSchemeSelectOpened = true" (blur)="colorSchemeSelectOpened = false" >
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" dropdownPosition="bottom">
              {{item.name}}
            </ng-template>
          </ng-select>
        </div>
        <div class="preferences-wraper">
          <div class="preferences-container" *ngIf="showPreferences">
            <div class="preferences-inner-container">
              <div class="preferences-header">
                <i class="fal fa-cog"></i>
                <span style="flex-grow: 1;">{{ 'dashboard:Preferences' | i18next }}</span>
                <i class="fal fa-times-circle" (click)="showPreferences = false"></i>
              </div>
              <app-preferences [gridItem]="gridItem" [colorScheme]="gridItem.colorScheme"></app-preferences>
            </div>
          </div>
          <button matButton class="primary-button" (click)="showPreferences = true"><i class="fal fa-cog"></i> {{
            'dashboard:Preferences' | i18next }}</button>
        </div>
      </div>
      <div class="widget-container" [class.widget-container-reports]="gridItem.componentType === 3">
        <app-widget-container class="app-widget-container" [gridItem]="gridItem" [isInWizard]="true" [stepper]="this.stepper"
          [colorSchemeId]="colorSchemeId" [dataNotifier]="dataNotifier"></app-widget-container>
      </div>
    </div>
    <footer class="footer-preview">
      <button matButton class="secondary-button" matStepperPrevious>{{ 'Previous' | i18next }}</button>
      <div>
        <button matButton [ngClass]="['secondary-button', 'cancel-button']" (click)="backToDashboard()">{{ 'Cancel' | i18next
          }}</button>
        <button matButton matStepperNext class="primary-button" (click)="addWidget()"
          [disabled]="gridItem.colorScheme==null">{{ 'Done' | i18next }}</button>
      </div>
    </footer>
  </mat-step>
  <ng-template matStepperIcon="edit" let-index="index">
    <i class="far fa-check"></i>
    <!--  {{index+1}}  -->
  </ng-template>

</mat-horizontal-stepper>
